var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-img-login",style:({backgroundImage:("url(" + _vm.sideImg)})},[_c('div',{staticClass:"logo-vacina"},[_c('img',{attrs:{"src":_vm.logoImg,"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }